import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
  FiHome,
  FiUsers,
  FiTruck,
  FiPhone,
  FiTool,
  FiUserCheck,
  FiSliders,
  FiBriefcase,
  FiSettings,
  FiClipboard,
  FiGlobe,
  FiLink,
  FiActivity,
  FiMonitor,
  FiFileText,
  FiBarChart2,
  FiMessageSquare,
  FiUserPlus,
  FiTag,
  FiDollarSign,
  FiFile,
  FiSend,
  FiMail,
  FiSmartphone,
  FiMessageCircle,
  FiClock,
  FiCheckSquare,
} from 'react-icons/fi';
import { SimboloCentralMax } from '../Logo';
import './Sidebar.css';

const menuSections = [
  {
    label: 'Home',
    items: [
      { path: '/dashboard', label: 'Dashboard', icon: FiHome, modulo: 'dashboard' },
    ],
  },
  {
    label: 'Cadastros',
    items: [
      { path: '/empresas', label: 'Empresas', icon: FiBriefcase, modulo: 'empresas' },
      { path: '/clientes', label: 'Beneficiários', icon: FiUsers, modulo: 'clientes' },
      { path: '/servicos', label: 'Serviços', icon: FiSettings, modulo: 'servicos' },
      { path: '/planos', label: 'Planos', icon: FiClipboard, modulo: 'planos' },
      // Logo abaixo de Planos porque o checklist se prende ao tipo de
      // atendimento, que é cadastrado ali dentro.
      { path: '/checklists', label: 'Checklists', icon: FiCheckSquare, modulo: 'planos' },
      { path: '/veiculos', label: 'Veículos', icon: FiTruck, modulo: 'veiculos' },
      { path: '/prestadores', label: 'Prestadores', icon: FiTool, modulo: 'prestadores' },
    ],
  },
  {
    label: 'Atendimento',
    items: [
      { path: '/painel', label: 'Painel', icon: FiMonitor, modulo: 'acionamentos' },
      { path: '/acionamentos', label: 'Acionamentos', icon: FiPhone, modulo: 'acionamentos' },
      { path: '/atendimentos-online', label: 'Atend. Online', icon: FiGlobe, modulo: 'acionamentos' },
      { path: '/links-online', label: 'Links Online', icon: FiLink, modulo: 'acionamentos' },
      // Fica em Atendimento porque é fila de quem está esperando socorro, e não
      // assunto financeiro: quem abre esta tela está com alguém na estrada.
      { path: '/cotacoes', label: 'Cotações', icon: FiDollarSign, modulo: 'acionamentos' },
      // Fica em Atendimento, e não em Sistema: plantão é assunto de quem opera,
      // consultado no meio do turno, não na hora de configurar alguma coisa.
      { path: '/jornadas', label: 'Jornadas', icon: FiClock, modulo: 'acionamentos' },
    ],
  },
  {
    label: 'Financeiro',
    items: [
      { path: '/pagamentos', label: 'Pagamentos', icon: FiDollarSign, modulo: 'fechamentos' },
      { path: '/faturamentos', label: 'Faturamentos', icon: FiFile, modulo: 'fechamentos' },
      { path: '/fechamentos', label: 'Fechamentos', icon: FiFileText, modulo: 'fechamentos' },
      { path: '/relatorios', label: 'Relatórios', icon: FiBarChart2, modulo: 'relatorios' },
    ],
  },
  {
    // Fica no Financeiro, e não em Gates: nota fiscal é assunto de quem fatura,
    // consultado junto com fechamento e faturamento. O token dela é que mora
    // com os outros gates, porque é credencial da central como as demais.
    label: 'Notas Fiscais',
    items: [
      { path: '/notas-fiscais', label: 'Notas Fiscais', icon: FiFileText, modulo: 'fechamentos' },
    ],
  },
  {
    label: 'Tickets',
    items: [
      { path: '/tickets-admin', label: 'Tickets', icon: FiMessageSquare, modulo: 'acionamentos' },
      { path: '/usuarios-portal', label: 'Usuários Portal', icon: FiUserPlus, modulo: 'acionamentos' },
      { path: '/categorias-tickets', label: 'Categorias', icon: FiTag, modulo: 'acionamentos' },
    ],
  },
  {
    label: 'Gates',
    items: [
      { path: '/gate-email', label: 'Gate E-mail', icon: FiMail, modulo: 'operadores' },
      { path: '/gate-whatsapp', label: 'Gate WhatsApp', icon: FiMessageCircle, modulo: 'operadores' },
      { path: '/gate-sms', label: 'Gate SMS', icon: FiSmartphone, modulo: 'operadores' },
      { path: '/gate-asaas', label: 'Gate Cobrança', icon: FiDollarSign, modulo: 'operadores' },
      { path: '/comunicacoes', label: 'Histórico', icon: FiSend, modulo: 'operadores' },
    ],
  },
  {
    label: 'Sistema',
    items: [
      { path: '/operadores', label: 'Usuários', icon: FiUserCheck, modulo: 'operadores' },
      { path: '/api-placa', label: 'API Placa', icon: FiActivity, modulo: 'operadores' },
    ],
  },
  {
    label: 'Configurações',
    items: [
      /*
        SEM `modulo`, e de propósito: é a preferência PESSOAL de quem está
        logado, não uma configuração da central. Amarrar ao módulo `operadores`
        esconderia a tela justamente de quem passa o dia nela — o operador comum
        — para liberá-la a quem administra usuários, que é outra coisa.
      */
      { path: '/configuracoes', label: 'Meu painel', icon: FiSliders },
    ],
  },
];

export default function Sidebar({ isOpen }) {
  const { canAccessModule, usuario } = useAuth();

  const centralNome = usuario?.central?.nome || 'CentralMax';
  const logoDaCentral = usuario?.central?.logo_url || null;

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-brand">
        {/* Com logo próprio, ele SUBSTITUI o símbolo do produto: a marca da
            central é a que o operador precisa reconhecer, e duas marcas lado a
            lado não somam, competem. Sem logo, fica o símbolo, que é o que
            sempre foi. O nome ao lado permanece nos dois casos, porque logo
            pequeno é ambíguo e o nome não é.

            `object-fit: contain` porque logo enviado por cliente vem em
            qualquer proporção: o da TrackMax é quadrado (700×700), e sem isso
            um logo largo seria esmagado dentro do quadrado de 30px. */}
        {logoDaCentral ? (
          <img
            src={logoDaCentral}
            alt={centralNome}
            style={{ width: 30, height: 30, objectFit: 'contain', flexShrink: 0 }}
            /* Se o arquivo sumir do disco, o `<img>` quebrado é pior que marca
               nenhuma: some do layout em vez de virar ícone de imagem partida. */
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        ) : (
          <SimboloCentralMax tamanho={30} />
        )}
        {isOpen && <h2>{centralNome}</h2>}
      </div>
      <nav className="sidebar-nav">
        {menuSections.map((section) => {
          const visibleItems = section.items.filter(
            (item) => !item.modulo || canAccessModule(item.modulo)
          );
          if (visibleItems.length === 0) return null;
          return (
            <React.Fragment key={section.label}>
              <div className="sidebar-section">{section.label}</div>
              {visibleItems.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `sidebar-link ${isActive ? 'active' : ''}`
                    }
                    title={item.label}
                  >
                    <Icon size={21} />
                    <span>{item.label}</span>
                  </NavLink>
                );
              })}
            </React.Fragment>
          );
        })}
      </nav>
    </aside>
  );
}
